
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeslotId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playoutCompare"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programmingDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeslotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeslotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"playoutCompare"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playoutCompare"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalUnique"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"perChannel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cellfind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tweet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uniquesPerChannel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cellfind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tweet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentThreads"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtopics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uniques"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":960}};
    doc.loc.source = {"body":"query($timeslotId: Int, $date: String, $unit: String, $playoutCompare: Int) {\n  programmingDashboard(timeslotId: $timeslotId, date: $date, unit: $unit, playoutCompare: $playoutCompare) {\n    engagement {\n      total\n      totalUnique\n      perChannel {\n        message\n        email\n        facebookPost\n        facebookComment\n        facebookMessage\n        instagram\n        cellfind\n        whatsapp\n        tweet\n        telegram\n        survey\n      }\n      uniquesPerChannel {\n        message\n        email\n        facebookPost\n        facebookComment\n        facebookMessage\n        instagram\n        cellfind\n        whatsapp\n        tweet\n        telegram\n        survey\n      }\n    }\n    contentThreads {\n      topics {\n        name\n        subtopics\n        weight\n      }\n    }\n    promotions {\n      entries {\n        name\n        value\n        campaignId\n      }\n      uniques {\n        name\n        value\n        campaignId\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/analytics/programmingDashboardBasicQuery.gql
// module id = 2575
// module chunks = 3